export default __webpack_public_path__ + "static/media/living-room2.3eff1e3a.jpg";